// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1-Tsm","calendarButtons":"ClockData_calendarButtons__2FE9Y"};